import React from "react";
import styles from "./style.module.css";
import { Button } from "aible";
import { toast } from "react-toastify";

import AlertComparison from "components/MonitoringMobile/AlertComparison";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import MobileBarChart from "components/MonitoringMobile/MobileBarChart";

export default class AlertCard extends React.Component {
  handleClick() {
    toast("Project owner has been notified for Adjust Change!", {
      type: toast.TYPE.SUCCESS,
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3500
    });
  }

  render() {
    const { card, total, num } = this.props;

    return (
      <div className={styles.alertCard}>
        <div className={styles.headerAlert}>
          <span className={styles.headerIcon}>
            <FontAwesomeIcon icon={faExclamationTriangle}></FontAwesomeIcon>
          </span>
          Alert {num} of {total}
        </div>
        <div className={styles.cardBody}>
          <div className={styles.alertTitle}>{card.title}</div>
          <MobileBarChart barData={card.barData} />
          <div className={styles.alertDetails}>
            {card.details}
            <br />
            <br />
            {card.recommend}
          </div>
          {/* <Button type="secondary" style={{ marginTop: '20px', width: 'inherit' }} onClick={() => this.handleClick()}>
                            {"Request Status Update from Owner"}
                        </Button> */}
          {/* enable when backend alert functionality is in */}
        </div>
      </div>
    );
  }
}
